import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface QrCodeModel {
  qrCode?: string;
}

class GetQrCodesRequest {
  recId?: number;
}

class GetQrCodesResponse {
  qrCodes?: QrCodeModel[];
}

class CreateQrCodeRequest {
  recId?: number;
  qrCode?: QrCodeModel;
}

class UpdateQrCodeRequest {
  recId?: number;
  originalQrCode?: string;
  qrCode?: QrCodeModel;
}

class DeleteQrCodeRequest {
  recId?: number;
  qrCode?: string;
}

export const qrCodeAPI = {
  async getQrCodes(recId: number): Promise<Result<QrCodeModel[]>> {
    let response = await backendApi.sendAndGetResponseAsync<GetQrCodesResponse>(
      "GetQrCodes",
      { recId: recId } as GetQrCodesRequest,
    );

    if (response.ok) {
      return { ok: true, value: response.value.qrCodes ?? [] };
    }

    return response;
  },

  async createQrCode(recId: number, qrCode: QrCodeModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateQrCode", {
      recId: recId,
      qrCode: qrCode,
    } as CreateQrCodeRequest);

    if (response.ok) {
      return { ok: true, value: "" };
    }

    TrimValidationFields(response.problem, "QrCode");

    return response;
  },

  async updateQrCode(
    recId: number,
    originalQrCode: string,
    qrCode: QrCodeModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateQrCode", {
      recId: recId,
      originalQrCode: originalQrCode,
      qrCode: qrCode,
    } as UpdateQrCodeRequest);

    if (response.ok) {
      return { ok: true, value: "" };
    }

    TrimValidationFields(response.problem, "QrCode");

    return response;
  },

  async deleteQrCode(recId: number, qrCode: QrCodeModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteQrCode", {
      recId: recId,
      qrCode: qrCode,
    } as DeleteQrCodeRequest);

    if (response.ok) {
      return { ok: true, value: response.value.qrCodes ?? [] };
    }

    TrimValidationFields(response.problem, "QrCode");

    return response;
  },
};
